/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PriceValueResponse } from './';
import {
    PriceValueResponseFromJSON,
    PriceValueResponseFromJSONTyped,
    PriceValueResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface ConsultingOfferResponse
 */
export interface ConsultingOfferResponse {
    /**
     * 
     * @type {PriceValueResponse}
     * @memberof ConsultingOfferResponse
     */
    hourlyRate: PriceValueResponse;
    /**
     * 
     * @type {string}
     * @memberof ConsultingOfferResponse
     */
    description?: string;
}

/**
 * Check if a given object implements the ConsultingOfferResponse interface.
 */
export function instanceOfConsultingOfferResponse(value: object): value is ConsultingOfferResponse {
    if (!('hourlyRate' in value) || value['hourlyRate'] === undefined) return false;
    return true;
}

export function ConsultingOfferResponseFromJSON(json: any): ConsultingOfferResponse {
    return ConsultingOfferResponseFromJSONTyped(json, false);
}

export function ConsultingOfferResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsultingOfferResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'hourlyRate': PriceValueResponseFromJSON(json['hourlyRate']),
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function ConsultingOfferResponseToJSON(value?: ConsultingOfferResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'hourlyRate': PriceValueResponseToJSON(value['hourlyRate']),
        'description': value['description'],
    };
}

